module.exports = __webpack_public_path__ + "static/media/favorite.197ce67d.svg";